/* CmdbNotificationComponent.js */

"use strict";

// const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const NotificationComponent = require("@gluenetworks/notification_component");

class CmdbNotificationComponent extends NotificationComponent {
    constructor(logger, userSession, options, value) {
        super(logger, userSession, options, value);
        this._scheduleWorkInput = value;
    }

    resetCmdbNotificationComponent(opts) {
        if (opts) {
            this._logger = opts.logger || this._logger;
            this._userSession = opts.userSession || this._userSession;
            this._scheduleWorkInput = opts.value || this._scheduleWorkInput;
            this._options = opts.options || this._options;
        }
        this.setValue(this._scheduleWorkInput);
        this.renderValue();
    }

    setValue(value) {
        this._scheduleWorkInput = value;
        this.notifyMe = _.get(this._scheduleWorkInput, "notifyMe", null);
        this.notifyEmail = _.get(this._scheduleWorkInput, "notifyEmail", null);
        this.notifyActionGroupDefault = _.get(
            this._scheduleWorkInput,
            "notifyActionGroupDefault",
            null
        );
    }

    renderValue() {
        const renderer = this._renderer;
        renderer._notifyMeCheckBox.setValue(!!this.notifyMe);
        renderer._notifySystemAdminCheckBox.setValue(!!this.notifyActionGroupDefault);
        if (this.notifyEmail && this.notifyEmail.length > 0) {
            renderer._notifyOtherCheckBox.setValue(true);
            const notifyEmailAsString = this.notifyEmail.join(", ");
            renderer._notifyOtherEmailInput.setValue(notifyEmailAsString);
        } else {
            renderer._notifyOtherCheckBox.setValue(false);
            renderer._notifyOtherEmailInput.setValue("");
        }
        renderer._rebuildEmailList();
    }

    setDisabled(disabled = true) {
        const renderer = this._renderer;
        if (disabled && !renderer._disabledMask) {
            renderer._disabledMask = document.createElement("disabled-mask-gl");
            renderer._disabledMask.classList.add("visible");
            renderer._rootElem.appendChild(renderer._disabledMask);
        } else if (!disabled && renderer._disabledMask) {
            renderer._disabledMask.remove();
            renderer._disabledMask = undefined;
        }
    }

    getValue() {
        return this._scheduleWorkInput;
    }
}

module.exports = CmdbNotificationComponent;
